import React from 'react';
import ListPageLayout from '@layouts/ListPageLayout';
import {withRouter} from 'react-router'

import WalletHistoryFilterForm from './WalletHistoryFilterForm';
import WalletHistoryListTable from './WalletHistoryListTable';
import UserBetRecordModal from '@ViewsDashboard/User/UserList/UserBetRecord/UserBetRecordModal';
import AgentModal from '@ViewsDashboard/Agent/AgentList/AgentDetail/AgentDetailModal';

import update_to_agent_store from '@store/Agent/UpdateToAgentStore';
import wallet_store, {filter_store, WalletItemStore} from '@store/Statistic/WalletHistory/WalletHistoryStore';

import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class WalletHistoryList extends React.PureComponent {

    constructor(props) {
        super();
        this.state = {
            Types: '2'
        }
        let state = props.location.state;
        ;

        this.updateDatas(state);
    }

    componentWillReceiveProps(props) {
        let state = props.location.state;

        this.updateDatas(state);
    }

    updateDatas(state) {
        if (state == undefined) {
            breadcrumb_store.resetByName('提现记录', '提现记录')

            filter_store.resetAttr()
        } else {
            if (state.type == WalletItemStore.Type_Cash) {
                breadcrumb_store.resetByName('提现记录', '提现记录')
            } else {
                breadcrumb_store.resetByName('充值记录', '充值记录')
            }

            wallet_store.currentType = state.type;

            filter_store.setAttr(state)
        }
    }

    // updateDatas(state) {
    //   if (state == undefined)
    //   {
    //     breadcrumb_store.resetByName('提现记录','提现记录')

    //     filter_store.resetAttr()
    //   }
    //   else
    //   {
    //     if (state == WalletItemStore.Type_Cash)
    //     {
    //       breadcrumb_store.resetByName('提现记录','提现记录')
    //     }
    //     else
    //     {
    //       breadcrumb_store.resetByName('充值记录','充值记录')
    //     }

    //     wallet_store.currentType = '2';

    //     filter_store.setAttr(state)
    //   }
    // }

    showAddNewAgentModal = () => {
        update_to_agent_store.openModal();
    }

    render() {
        return (
            <ListPageLayout

                isCustomHeader
                header={
                    <WalletHistoryFilterForm Types={this.state.Types}/>
                }
                list={
                    <WalletHistoryListTable Types={this.state.Types}/>
                }
                modal={
                    <div>
                        <UserBetRecordModal/>
                        <AgentModal/>
                    </div>
                }
            />
        );
    }
}

export default WalletHistoryList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/WalletHistory/WalletHistoryList1.jsx